import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

const TYPE_CONFIG = {
  business:  { icon:'🏢', color:'#6366f1', label:'Business'  },
  heritage:  { icon:'🏛️', color:'#f59e0b', label:'Heritage'  },
  nature:    { icon:'🌿', color:'#22c55e', label:'Nature'    },
  event:     { icon:'🎪', color:'#ec4899', label:'Event'     },
  emergency: { icon:'🚑', color:'#ef4444', label:'Emergency' },
  tourism:   { icon:'🗺️', color:'#3b82f6', label:'Tourism'   },
  education: { icon:'🎓', color:'#8b5cf6', label:'Education' },
  transport: { icon:'🚌', color:'#64748b', label:'Transport' },
  community: { icon:'🤝', color:'#06b6d4', label:'Community' },
  public:    { icon:'🏛️', color:'#94a3b8', label:'Public'    },
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{margin:0;}
.ex-root{height:100vh;height:100dvh;display:flex;flex-direction:column;background:#080b14;font-family:'DM Sans',sans-serif;color:#e2e8f0;overflow:hidden;}
.ex-header{display:flex;align-items:center;gap:10px;padding:10px 14px;background:rgba(8,11,20,.97);border-bottom:1px solid rgba(255,255,255,.07);flex-shrink:0;z-index:20;}
.ex-logo{font-weight:800;font-size:16px;color:#fff;text-decoration:none;margin-right:4px;}
.ex-logo span{color:#f5a623;}
.ex-search{flex:1;display:flex;align-items:center;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);border-radius:10px;padding:0 12px;gap:8px;}
.ex-search input{flex:1;background:transparent;border:none;color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:14px;outline:none;padding:9px 0;}
.ex-search input::placeholder{color:#475569;}
.ex-locate-btn{width:38px;height:38px;border-radius:10px;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.06);color:#e2e8f0;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .2s;}
.ex-locate-btn:hover{background:rgba(255,255,255,.12);}
.ex-content{flex:1;display:flex;overflow:hidden;position:relative;}
/* Filter bar */
.ex-filters{position:absolute;top:10px;left:50%;transform:translateX(-50%);z-index:10;display:flex;gap:6px;padding:0 14px;overflow-x:auto;max-width:100%;pointer-events:none;}
.ex-filters::-webkit-scrollbar{display:none;}
.ex-filter-btn{pointer-events:all;padding:6px 12px;border-radius:99px;border:1px solid rgba(255,255,255,.15);background:rgba(8,11,20,.88);color:#94a3b8;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:all .18s;font-family:'DM Sans',sans-serif;}
.ex-filter-btn.active{color:#fff;}
/* Map placeholder */
.ex-map{flex:1;position:relative;background:#0d1520;}
.ex-map-iframe{width:100%;height:100%;border:none;}
/* Side panel */
.ex-panel{width:340px;flex-shrink:0;overflow-y:auto;border-left:1px solid rgba(255,255,255,.07);background:rgba(8,11,20,.97);display:flex;flex-direction:column;}
@media(max-width:700px){.ex-panel{position:absolute;bottom:0;left:0;right:0;width:100%;max-height:55vh;border-left:none;border-top:1px solid rgba(255,255,255,.1);border-radius:18px 18px 0 0;}}
.ex-panel-hd{padding:14px 16px 10px;border-bottom:1px solid rgba(255,255,255,.07);flex-shrink:0;}
.ex-panel-title{font-size:12px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:1.5px;}
.ex-place-card{padding:12px 16px;border-bottom:1px solid rgba(255,255,255,.05);cursor:pointer;transition:background .15s;display:flex;gap:11px;align-items:flex-start;}
.ex-place-card:hover{background:rgba(255,255,255,.04);}
.ex-place-card.selected{background:rgba(99,102,241,.08);}
.ex-place-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;}
.ex-place-name{font-size:13px;font-weight:600;color:#e2e8f0;margin-bottom:2px;}
.ex-place-type{font-size:10px;text-transform:uppercase;letter-spacing:1px;font-weight:700;}
.ex-place-addr{font-size:11px;color:#475569;margin-top:2px;}
.ex-place-stats{display:flex;gap:8px;margin-top:4px;}
.ex-place-stat{font-size:10px;color:#64748b;}
/* Detail panel */
.ex-detail{padding:16px;}
.ex-detail-cover{width:100%;height:140px;object-fit:cover;border-radius:12px;margin-bottom:14px;background:#1a2540;display:flex;align-items:center;justify-content:center;font-size:52px;}
.ex-detail-name{font-size:18px;font-weight:800;color:#e2e8f0;margin-bottom:4px;}
.ex-detail-type{font-size:11px;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px;}
.ex-detail-desc{font-size:13px;color:#94a3b8;line-height:1.65;margin-bottom:14px;}
.ex-detail-btn{width:100%;padding:11px;border-radius:10px;border:none;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:700;cursor:pointer;margin-bottom:8px;display:flex;align-items:center;justify-content:center;gap:6px;transition:all .18s;}
.ex-checkin-btn{color:#fff;}
.ex-view-btn{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);color:#e2e8f0;}
.ex-add-place-btn{position:absolute;bottom:16px;right:16px;z-index:15;padding:10px 16px;border-radius:12px;border:none;background:rgba(8,11,20,.9);border:1px solid rgba(255,255,255,.15);color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px;transition:all .2s;}
.ex-add-place-btn:hover{background:rgba(255,255,255,.1);}
.ex-spinner{width:24px;height:24px;border:2px solid rgba(99,102,241,.2);border-top-color:#6366f1;border-radius:50%;animation:spin .7s linear infinite;margin:20px auto;}
@keyframes spin{to{transform:rotate(360deg)}}
.ex-empty{text-align:center;padding:30px 16px;color:#334155;font-size:13px;}
`;

export default function Explore() {
  const navigate = useNavigate();
  const [places,   setPlaces]   = useState([]);
  const [selected, setSelected] = useState(null);
  const [filter,   setFilter]   = useState('all');
  const [search,   setSearch]   = useState('');
  const [loading,  setLoading]  = useState(true);
  const [userPos,  setUserPos]  = useState(null);
  const [checkedIn, setCheckedIn] = useState(false);
  const debounceRef = useRef(null);

  const fetchPlaces = useCallback(async (q='', type='') => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ limit: 60 });
      if (type && type !== 'all') params.set('type', type);
      if (q) params.set('search', q);
      const { data } = await axios.get(`${API_BASE}/places?${params}`);
      setPlaces(data.places || []);
    } catch { setPlaces([]); } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchPlaces(); }, [fetchPlaces]);

  const handleSearch = (v) => {
    setSearch(v);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchPlaces(v, filter), 400);
  };

  const handleFilter = (type) => {
    setFilter(type);
    fetchPlaces(search, type);
  };

  const locateMe = () => {
    if (!navigator.geolocation) return alert('Geolocation not supported');
    navigator.geolocation.getCurrentPosition(
      pos => {
        setUserPos({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        // Fetch nearby
        axios.get(`${API_BASE}/places/nearby?lat=${pos.coords.latitude}&lng=${pos.coords.longitude}&radius=3000`)
          .then(({ data }) => setPlaces(data))
          .catch(() => {});
      },
      () => alert('Could not get location')
    );
  };

  const checkIn = async (place) => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    try {
      await axios.post(`${API_BASE}/places/${place._id}/checkin`, { method: 'gps' }, { headers: { Authorization: `Bearer ${token}` } });
      setCheckedIn(true);
      setTimeout(() => setCheckedIn(false), 3000);
    } catch (e) { alert(e.response?.data?.error || 'Check-in failed'); }
  };

  const cfg = (type) => TYPE_CONFIG[type] || TYPE_CONFIG.public;
  const mapCenter = selected
    ? { lat: selected.location.coordinates[1], lng: selected.location.coordinates[0] }
    : userPos || { lat: 27.7172, lng: 85.3240 }; // Kathmandu default

  return (
    <div className="ex-root">
      <style>{CSS}</style>

      <div className="ex-header">
        <a href="/" className="ex-logo">flap<span>.</span></a>
        <div className="ex-search">
          <span style={{color:'#475569'}}>🔍</span>
          <input value={search} onChange={e=>handleSearch(e.target.value)} placeholder="Search places, businesses, events…"/>
          {search && <button onClick={()=>handleSearch('')} style={{background:'transparent',border:'none',color:'#475569',cursor:'pointer',fontSize:16}}>✕</button>}
        </div>
        <button className="ex-locate-btn" onClick={locateMe} title="Find my location">📍</button>
      </div>

      <div className="ex-content">
        {/* Type filters */}
        <div className="ex-filters">
          {[['all','🗺️ All'],['business','🏢'],['heritage','🏛️'],['nature','🌿'],['event','🎪'],['emergency','🚑'],['tourism','🗺️'],['education','🎓']].map(([type,label])=>(
            <button key={type} className={`ex-filter-btn${filter===type?' active':''}`}
              style={filter===type?{background:cfg(type).color,borderColor:cfg(type).color}:{}}
              onClick={()=>handleFilter(type)}>
              {label}{type!=='all'?' '+cfg(type).label:''}
            </button>
          ))}
        </div>

        {/* Map (OpenStreetMap embed) */}
        <div className="ex-map">
          <iframe
            className="ex-map-iframe"
            title="World Map"
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${mapCenter.lng-.05},${mapCenter.lat-.05},${mapCenter.lng+.05},${mapCenter.lat+.05}&layer=mapnik${selected?`&marker=${mapCenter.lat},${mapCenter.lng}`:''}`}
          />
          <button className="ex-add-place-btn" onClick={()=>navigate('/places/new')}>
            ➕ Add Place
          </button>
        </div>

        {/* Side panel */}
        <div className="ex-panel">
          {selected ? (
            <div className="ex-detail">
              <button onClick={()=>setSelected(null)} style={{background:'transparent',border:'none',color:'#6366f1',cursor:'pointer',fontSize:13,fontFamily:'DM Sans,sans-serif',fontWeight:600,marginBottom:14,padding:0}}>← All places</button>
              {selected.coverPhoto
                ? <img src={selected.coverPhoto} alt={selected.name} className="ex-detail-cover"/>
                : <div className="ex-detail-cover">{cfg(selected.type).icon}</div>
              }
              <div className="ex-detail-name">{selected.name}</div>
              <div className="ex-detail-type" style={{color:cfg(selected.type).color}}>{cfg(selected.type).icon} {cfg(selected.type).label}</div>
              {selected.shortDesc && <p className="ex-detail-desc">{selected.shortDesc}</p>}
              {selected.description && !selected.shortDesc && <p className="ex-detail-desc">{selected.description.slice(0,200)}{selected.description.length>200?'…':''}</p>}
              {selected.address && <div style={{fontSize:12,color:'#475569',marginBottom:12}}>📍 {selected.address}</div>}
              <div style={{display:'flex',gap:12,marginBottom:14}}>
                {selected.totalCheckIns > 0 && <span style={{fontSize:12,color:'#64748b'}}>📍 {selected.totalCheckIns} check-ins</span>}
                {selected.avgRating > 0   && <span style={{fontSize:12,color:'#fbbf24'}}>★ {selected.avgRating}</span>}
              </div>
              {checkedIn && <div style={{background:'rgba(52,211,153,.1)',border:'1px solid rgba(52,211,153,.25)',borderRadius:10,padding:'10px 14px',marginBottom:12,fontSize:13,color:'#34d399',fontWeight:600}}>✅ Checked in!</div>}
              <button className="ex-detail-btn ex-checkin-btn" style={{background:`linear-gradient(135deg,#6366f1,#8b5cf6)`}} onClick={()=>checkIn(selected)}>
                📍 Check In
              </button>
              {selected.businessId && (
                <button className="ex-detail-btn ex-view-btn" onClick={()=>navigate(`/b/${selected.slug||selected._id}`)}>
                  🏢 View Business Page
                </button>
              )}
              {selected.type === 'event' && selected.event?.ticketUrl && (
                <a href={selected.event.ticketUrl} target="_blank" rel="noreferrer" className="ex-detail-btn ex-view-btn" style={{textDecoration:'none',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
                  🎟️ Get Tickets
                </a>
              )}
            </div>
          ) : (
            <>
              <div className="ex-panel-hd">
                <div className="ex-panel-title">{places.length} Places {filter!=='all'?`· ${cfg(filter).label}`:''}</div>
              </div>
              {loading ? <div className="ex-spinner"/> :
               places.length === 0 ? <div className="ex-empty">No places found.<br/>Be the first to add one!</div> :
               places.map(p => (
                <div key={p._id} className={`ex-place-card${selected?._id===p._id?' selected':''}`} onClick={()=>setSelected(p)}>
                  <div className="ex-place-icon" style={{background:`${cfg(p.type).color}22`}}>{cfg(p.type).icon}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div className="ex-place-name">{p.name}</div>
                    <div className="ex-place-type" style={{color:cfg(p.type).color}}>{cfg(p.type).label}</div>
                    {p.address && <div className="ex-place-addr">{p.address}</div>}
                    <div className="ex-place-stats">
                      {p.totalCheckIns > 0 && <span className="ex-place-stat">📍 {p.totalCheckIns}</span>}
                      {p.avgRating > 0      && <span className="ex-place-stat">★ {p.avgRating}</span>}
                      {p.isFeatured         && <span style={{fontSize:10,color:'#f59e0b'}}>⭐ Featured</span>}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}